module.exports = __webpack_public_path__ + "files/f9721295146a5369738bc6b1c6cb8bba.png";